import React from 'react'

import HeaderDropdown from './HeaderDropdown'
import HeartIcon from 'components/Icons/Heart'
import { useWishlistContext } from 'store/WishlistContext'
import HeaderWishlistItem from '../components/HeaderWishlistItem'

const WishlistDropdown = ({ open, onClose }) => {
  const { wishlistProducts } = useWishlistContext()

  return (
    <HeaderDropdown
      open={open}
      onClose={onClose}
      title="ჩემი სურვილების სია"
      items={wishlistProducts}
      emptyIcon={HeartIcon}
      emptyTitle="სურვილების სია ცარიელია"
      emptyMessage="გთხოვთ აირჩიოთ პროდუქცია"
      buttonText="ყველას ნახვა"
      buttonRoute="/wishlist"
      rightOffset="right-[-50px] md:-right-6"
      tooltipRightOffset="right-[59px] md:right-[38px]"
      renderItem={product => <HeaderWishlistItem product={product} />}
    />
  )
}

export default WishlistDropdown
